import poopImage from "../assets/poop.png";
export class Monster {
  x: number;
  y: number;
  width: number;
  height: number;
  image: HTMLImageElement;

  hitboxX: number;
  hitboxY: number;
  hitboxWidth: number;
  hitboxHeight: number;

  constructor(randomX: number) {
    this.x = randomX;
    this.y = 0;
    this.width = 40;
    this.height = 40;
    this.image = new Image();
    this.image.src = poopImage;

    this.hitboxX = this.x + 5;
    this.hitboxY = this.y + 5;
    this.hitboxWidth = 30;
    this.hitboxHeight = 30;
  }

  down(stage: number) {
    if (stage === 1) {
      this.y += 5;
      this.hitboxY += 5;
    } else if (stage === 2 || stage === 3) {
      this.y += 6;
      this.hitboxY += 6;
    } else {
      this.y += 6.5;
      this.hitboxY += 6.5;
    }
  }

  draw(ctx: CanvasRenderingContext2D) {
    ctx.fillStyle = "red";
    // ctx.fillRect(
    //   this.hitboxX,
    //   this.hitboxY,
    //   this.hitboxWidth,
    //   this.hitboxHeight
    // );
    ctx.drawImage(this.image, this.x, this.y, this.width, this.height);
  }
}
